import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "../../Assets/CSS/Styles.scss";
import { API_BASE_URL } from '../../config';
const CaseStudyDetail = () => {
  const { id } = useParams();
  const [caseStudy, setCaseStudy] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API_BASE_URL}/api/blogs/${id}`) // Make sure your backend route matches
      .then((res) => {
        setCaseStudy(res.data);
      })
      .catch((err) => {
        console.error("Error fetching case study:", err);
        setCaseStudy(null);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return isNaN(date) ? "Unknown date" : date.toLocaleDateString();
  };

  if (loading) return <p className="text-center py-10">Loading case study...</p>;
  if (!caseStudy) return <p className="text-center py-10">No case study available.</p>;

  return (
    <div className="container mx-auto px-4 sm:px-6 py-6 sm:py-8 md:py-12 max-w-4xl mt-8 sm:mt-12 md:mt-16 mt60">
      {/* Card Container */}
      <div className="bg-white rounded-lg md:rounded-xl shadow-lg md:shadow-2xl overflow-hidden transition-all duration-300 hover:shadow-xl md:hover:shadow-3xl">
        {/* Image with responsive height */}
        {caseStudy.image && (
          <div className="relative">
            <img
              src={`${API_BASE_URL}/uploads/${caseStudy.image}`}
              alt={caseStudy.title}
              className="w-full h-48 sm:h-64 md:h-80 lg:h-96 object-cover shadow-sm md:shadow-md rounded-t-lg md:rounded-t-xl"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
          </div>
        )}

        {/* Card Body with responsive padding */}
        <div className="p-4 sm:p-6 md:p-8">
          {/* Responsive title */}
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-2 sm:mb-3 text-gray-800 [text-shadow:_0_1px_1px_rgb(0_0_0_/_0.1)] md:[text-shadow:_0_1px_2px_rgb(0_0_0_/_0.1)]">
            {caseStudy.title}
          </h1>

          {/* Overview with responsive text */}
          {caseStudy.overview && (
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6">
              {caseStudy.overview}
            </p>
          )}

          {/* Author & Date with responsive layout */}
          <div className="flex flex-wrap items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
            <span className="text-xs sm:text-sm text-gray-500 px-2 sm:px-3 py-1 bg-gray-100 rounded-full">
              By {caseStudy.author || "Unknown"}
            </span>
            <span className="text-gray-400 hidden sm:block">•</span>
            <span className="text-xs sm:text-sm text-gray-500 px-2 sm:px-3 py-1 bg-gray-100 rounded-full">
              {caseStudy.publishDate ? formatDate(caseStudy.publishDate) : "No date"}
            </span>
          </div>

          {/* Sections with responsive spacing */}
          {caseStudy.sections?.length > 0 &&
            caseStudy.sections.map((section, index) => (
              <div
                key={index}
                className="mb-4 sm:mb-6 pb-4 sm:pb-6 border-b p-3 sm:p-4 transition-all duration-200 hover:bg-gray-50/50 hover:shadow-xs sm:hover:shadow-sm rounded-md sm:rounded-lg"
              >
                {section.title && (
                  <h2 className="text-xl sm:text-2xl font-semibold mb-2 sm:mb-3 text-gray-800 [text-shadow:_0_1px_1px_rgb(0_0_0_/_0.05)]">
                    {section.title}
                  </h2>
                )}
                {section.description && (
                  <p className="text-sm sm:text-base text-gray-700 mb-3 sm:mb-4">
                    {section.description}
                  </p>
                )}
                {section.points?.length > 0 && (
                  <ul className="list-disc ml-4 sm:ml-6 space-y-1 sm:space-y-2 text-sm sm:text-base text-gray-700 marker:text-blue-400">
                    {section.points.map((point, i) => (
                      <li
                        key={i}
                        className="pl-1 sm:pl-2 hover:pl-2 sm:hover:pl-3 transition-all duration-150"
                        dangerouslySetInnerHTML={{ __html: point }}
                      ></li>
                    ))}
                  </ul>
                )}
              </div>
            ))}

          {/* Conclusion with responsive styling */}
          {caseStudy.fullContent?.conclusion && (
            <div className="mt-6 sm:mt-8 p-3 sm:p-4 bg-gray-50 rounded-md sm:rounded-lg">
              <h3 className="text-lg sm:text-xl font-semibold mb-2 sm:mb-3 text-gray-800">
                Conclusion
              </h3>
              <p className="text-sm sm:text-base text-gray-700">
                {caseStudy.fullContent.conclusion}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CaseStudyDetail;
